import { equipmentGearCategoryList } from '../../Equipment/EquipmentGearCategory_Datas';

export const listTypeChoiceArray = ['SumList', 'PackList'];

export const listVisibilityChoiceArray = ['Everyone', 'Me'];

export const listCategoryChoiceArray = equipmentGearCategoryList.map(item => item.gearCategory);

export const listEnvironmentChoiceArray = ['Mountain', 'Desert', 'River', 'Sea', 'Forest', 'Snow'];
